export default `
  sys {
    id
    publishedAt
    firstPublishedAt
  }
  slug
  title
  category
  subcategory
  contentType: __typename
  seo {
    title
    description
    keywords
    ogImage {
      src
      frontifyAsset
    }
    noIndex
    noFollow
  }
`
